<div class="save-bar" [class.dirty]="warning()">
  <div class="save-message" role="status">
    <mat-icon aria-hidden="true">{{ warning() ? 'error_outline' : 'check_circle_outline' }}</mat-icon>
    {{ message() }}
  </div>
  <div class="save-actions">
    <button type="button" mat-button color="primary" [disabled]="!changed() || submitting()" (click)="discard.emit()">
      Zrušiť zmeny
    </button>
    <button type="submit" mat-raised-button color="primary" [disabled]="invalid() || !changed() || submitting()">
      Uložiť zmeny
    </button>
  </div>
</div>
